module.exports = ".dashboard-tile-button {\n  position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/components/recent-reports/list/simple-report-list.component.scss
// module id = ./src/app/dashboard/components/recent-reports/list/simple-report-list.component.scss
// module chunks = main